import React from "react";
import { UserAvatar } from "../../components/Atoms/Avatar";

interface Props {
  users: server.dto.UserSmall[]
}

const WhoCanReviewModalContent = (props: Props) => {
  return <div className="grow1 scrollbox-auto">
    <table className="s1_table list">
      <tbody>
        {props.users.map(u => <tr key={u.userId}>
          <td style={{ width: 50 }}>
            <UserAvatar user={u} />
          </td>
          <td>
            <h3>
              {u.fullName}
            </h3>
          </td>
        </tr>)}
      </tbody>
    </table >
  </div >;
};

export default WhoCanReviewModalContent;